module.exports = __webpack_public_path__ + "media/application/images/ui/badge-peoples-choice-with-text-small-22ffdfb95ef1eb4f647c193784d4bb1a.png";